import ActivitiesLazyWrapper from "../workshops/ActivitiesLazyWrapper";
import type { GeneralSettings } from "@/src/lib/types/header";

interface AdditionalActivitiesProps {
  additionalActivities?: {
    mainHeading?: string;
  };
  generalSettings?: GeneralSettings;
}

export default function AdditionalActivities({ additionalActivities, generalSettings }: AdditionalActivitiesProps) {
  return <ActivitiesLazyWrapper additionalActivities={additionalActivities} generalSettings={generalSettings} />;
}
